/**
 * Reports API Service
 *
 * Handles all report-generation API calls:
 * - Tenant pending bills report
 * - Cleared tenants bill report
 * - Property tenant reports
 */

import { post } from './client';

export const reportsApi = {
    /**
     * Get property tenant pending bills report
     * @param {Object} reportData
     * @param {string} reportData.landlord_id - Landlord ID
     * @returns {Promise<Object>} Pending bills report
     */
    getPropertyTenantPendingBills: async (reportData) => {
        // return post('pegasus/visionary/reports/get/property/tenant/pending-bills-report', reportData);
        return post('pegasus/visionary/reports/get/property/pending/tenants/bill', reportData);
    },

    /**
     * Get property cleared tenants bill report
     * @param {Object} reportData
     * @param {string} reportData.landlord_id - Landlord ID
     * @param {string} reportData.group_by - Optional grouping
     * @param {boolean} reportData.include_details - Include details flag
     * @param {string} reportData.format - Format (pdf/excel)
     * @returns {Promise<Object>} Cleared tenants report
     */
    getPropertyClearedTenantsBill: async (reportData) => {
        return post('pegasus/visionary/reports/get/property/cleared/tenants/bill', reportData);
    },

    /**
     * Get property pending tenants bill report
     * @param {Object} reportData
     * @param {string} reportData.landlord_id - Landlord ID
     * @param {string} reportData.group_by - Optional grouping
     * @param {boolean} reportData.include_details - Include details flag
     * @param {string} reportData.format - Format (pdf/excel)
     * @returns {Promise<Object>} Pending tenants report
     */
    getPropertyPendingTenantsBill: async (reportData) => {
        return post('pegasus/visionary/reports/get/property/pending/tenants/bill', reportData);
    },
};

export default reportsApi;
